<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('editGlobalUserPermissions.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text class="my-4">
      <div>
        <v-select
            v-model="filters.copyFromUser"
            :items="users"
            :item-value="item => item"
            item-text="name"
            clearable
            :label="$t('editGlobalUserPermissions.copyFromUserLabel')"
            @change="copyFromUserChanged()"
        ></v-select>
      </div>
      <v-form class="d-flex justify-space-between">
        <v-col cols="12" md="6">
          <template>
            <v-card
                :disabled="filters.copyFromUser !== null"
                class="mx-auto"
                max-width="600"
            >
              <v-card-title>
                <div class="d-flex">
                  <span>{{ $t('editGlobalUserPermissions.orgCardTitle') }}</span>
                  <div class="d-flex" style="height: 40px; margin-left: 180px">
                    <v-text-field
                        ref="searchInput"
                        @input="search()"
                        :label="$t('editGlobalUserPermissions.orgSearchPlaceholder')"
                        outlined
                        dense
                        row="1"
                        class="smaller-text-field"
                    ></v-text-field>
                  </div>
                </div>
              </v-card-title>

              <v-divider></v-divider>

              <v-progress-linear
                  v-if="loadingOrganizations"
                  indeterminate
                  color="primary"
              ></v-progress-linear>

              <v-virtual-scroll
                  :items="filteredOrganizations"
                  height="320"
                  item-height="48"
              >
                <template v-slot:default="{ item }">
                  <v-list-item>
                    <template v-slot:default>
                      <v-list-item-action>
                        <v-checkbox
                            v-model="item.IsActive"
                            color="primary"
                            @change="saveOrganizationChanges(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.Name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                            icon
                            color="secondary"
                            @click="handleButtonClick(item)"
                        >
                          <v-icon>mdi-page-next-outline</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-card>
          </template>
        </v-col>
        <v-col  cols="12" md="6">
          <template>
            <v-card class="mx-auto" max-width="600" :disabled="filters.copyFromUser !== null">
              <v-card-title>
                {{ $t('editGlobalUserPermissions.departmentCardTitle') }}
              </v-card-title>

              <v-divider></v-divider>

              <v-progress-linear
                  v-if="loadingUnits"
                  indeterminate
                  color="primary"
              ></v-progress-linear>

              <v-virtual-scroll :items="units" height="320" item-height="48">
                <template v-slot:default="{ item }">
                  <v-list-item>
                    <template v-slot:default>
                      <v-list-item-action>
                        <v-checkbox
                            v-model="item.IsActive"
                            color="primary"
                            @change="saveUnitChanges(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.Name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-card>
          </template>
        </v-col>
        <v-snackbar v-model="isServerError"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('common.messages.serverError') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="secondary" @click="onCancelButtonClicked">{{ $t('common.actions.cancel') }}</v-btn>
      <v-spacer/>
            <v-btn text color="primary" @click="onSaveButtonClicked">{{ $t('common.actions.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import GlobalUserUnitPermissionService from "@/services/global.user.unit.permission.service.";
import _ from "underscore";
import Mappers from "@/mappers";
import GlobalUserService from "@/services/global.user.service";
import unit from "@/domain/Unit";

export default {
  name: "EditGlobalUserUnitPermission",
  computed: {
    unit() {
      return unit
    }
  },
  props: {
    inn: String
  },
  data() {
    return {
      loading: false,
      loadingUnits: false,
      loadingOrganizations: false,
      filteredOrganizations: [],
      units: [],
      users: [],
      filters: {
        copyFromUser: null,
        organizationId: null,
        isSelectedAllOrganizations: false,
        isSelectedAllUnits: false
      },
      organizations: [],
      isServerError: false,
      user: null
    }
  },
  methods: {
    onSaveButtonClicked(){
      if(this.filters.copyFromUser !== null){
        this.loadingOrganizations = true
        this.loadingUnits = true
        var fromId = this.filters.copyFromUser.id
        var toId = this.user.id

        GlobalUserUnitPermissionService.copyFromUser({fromId: fromId, toId: toId})
            .finally( () => {
              this.loadingOrganizations = false
              this.loadingUnits = false
              this.filters.copyFromUser = null
              this.loadPermissionFromSelectedUser()
            })
      }
    },
    handleButtonClick(item){
      this.loadPermissions(this.user.id, item.Id)
    },
    search() {
      const searchValue = this.$refs.searchInput.internalValue;
      this.filteredOrganizations = this.organizations.filter(item => {
        return item.Name.toLowerCase().includes(searchValue.toLowerCase()) || item.Inn.includes(searchValue);
      });
    },
    set(user) {
      this.clear()
      this.user = user

      this.loadUsers()
      this.loadPermissionFromSelectedUser()
    },
    clear() {
      this.units = []
    },
    onCancelButtonClicked() {
      this.$emit('cancel')
    },
    loadPermissionFromSelectedUser(){
      this.loadingOrganizations = true
      var userId = this.user.id

      GlobalUserUnitPermissionService.getBySelectedUser({userId: userId})
          .then(response => {
            this.organizations = response.data
            this.filteredOrganizations = this.organizations
          })
          .finally( () => {
            if(this.filters.organizationId !== null){
              this.loadPermissions(userId, this.filters.organizationId)
            }
            else {
              this.loadPermissions(userId, this.organizations[0].Id)
            }
            this.loadingOrganizations = false
          })
    },
    loadPermissions(userId, organizationId) {
      this.loadingUnits = true
      this.filters.organizationId = organizationId

      GlobalUserUnitPermissionService.get({userId: userId, organizationId: organizationId})
          .then(response => {
            this.units = response.data
          })
          .finally( () => {
            this.loadingUnits = false
          })
    },
    loadUsers(){
      this.$store.dispatch(LAYOUT_LOADING_START)

      GlobalUserService.getUsers({skip: 0, limit: 1000})
          .then(response => {
            this.users = _.map(response.data.Records, o => {
              return Mappers.mapGlobalUser(o)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    copyFromUserChanged() {
      if (this.filters.copyFromUser === undefined) {
        this.filters.copyFromUser = null
      }
    },
    saveUnitChanges(unit){
      this.loading = true;
      this.isServerError = false

      GlobalUserUnitPermissionService.editUnit({
        userId: this.user.id,
        unitId: unit.UnitId,
        isActive: unit.IsActive
      })
          .then(() => {}, () => {
            this.isServerError = true
          })
          .finally(() => {
            this.loadPermissionFromSelectedUser()
            this.loading = false
          })
    },
    saveOrganizationChanges(organization){
      this.loading = true;
      this.isServerError = false

      GlobalUserUnitPermissionService.editOrganization({
        userId: this.user.id,
        organizationId: organization.Id,
        isActive: organization.IsActive
      })
          .then(() => {}, () => {
            this.isServerError = true
          })
          .finally(() => {
            this.loadPermissionFromSelectedUser()
            this.loading = false
          })
    }
  },
  watch: {
    'filters.copyFromUser': 'copyFromUserChanged',
  }
}
</script>

<style scoped>
.smaller-text-field {
  width: 250px;
}
</style>